import { Cable, Camera, Cctv, HardDrive, Network, Wrench } from "lucide-react";

export const GROUP_ICONS = { cable: Cable, components: Wrench, recorder: Cctv, cameras: Camera, storage: HardDrive, network: Network };

const PLUGS = "RJ45 CAT6 Connector Plugs (Pack of 100)";
const JACKS = "CAT6 Keystone Jack (Pack of 10)";
const TOOL = "RJ45 Crimping Tool with Cutter";

export const CABLING_KIT = {
  basePath: "/kit-builder",
  pageTestId: "kit-builder-page",
  labelKey: "kit_label",
  titleKey: "kit_title",
  subKey: "kit_sub",
  hintKey: "kit_hint",
  groups: [
    { key: "cable", titleKey: "kit_step_cable", type: "choice", required: true,
      names: ["Hikvision CAT6 UTP Network Cable 305m", "Vascolink CAT6 F/FTP Outdoor Cable 305m"] },
    { key: "components", titleKey: "kit_step_components", type: "qty",
      names: [PLUGS, JACKS, "CAT6 UTP Patch Cord 1m", "CAT6 UTP Patch Cord 3m", TOOL] },
  ],
  tier: (sel) => {
    if (!sel.find((s) => s.groupKey === "cable")) return { pct: 0, code: null };
    const has = (n) => sel.some((s) => s.product.name === n && s.qty > 0);
    const sub = sel.reduce((a, s) => a + s.product.price * s.qty, 0);
    if (has(PLUGS) && has(JACKS) && has(TOOL)) return { pct: 15, code: "KIT15" };
    if ((has(PLUGS) || has(JACKS) || has(TOOL)) && sub >= 50) return { pct: 10, code: "KIT10" };
    return { pct: 0, code: null };
  },
};

export const CCTV_KIT = {
  basePath: "/cctv-kit-builder",
  pageTestId: "cctv-kit-builder-page",
  labelKey: "cctvkit_label",
  titleKey: "cctvkit_title",
  subKey: "cctvkit_sub",
  hintKey: "cctvkit_hint",
  groups: [
    { key: "recorder", titleKey: "cctvkit_step_recorder", type: "choice", required: true,
      names: ["Hikvision 8-Channel NVR Kit", "Hikvision 16-Channel NVR (DS-7616NI-K2)",
              "Dahua 8-Channel PoE NVR (NVR2108HS-8P-I)", "Dahua 16-Channel NVR (NVR2216-I)"] },
    { key: "cameras", titleKey: "cctvkit_step_cameras", type: "qty",
      names: ["Hikvision 4MP Dome CCTV Camera", "Dahua 4MP IR Turret Camera (IPC-HDW2441T-S)",
              "Dahua 4MP IR Bullet Camera (IPC-HFW2441S-S)", "Hikvision 4MP 25x PTZ Dome Camera (DS-2DE4425IW-DE)"] },
    { key: "storage", titleKey: "cctvkit_step_storage", type: "choice",
      names: ["Hikvision 4TB Surveillance HDD", "Hikvision 8TB Surveillance HDD"] },
    { key: "network", titleKey: "cctvkit_step_network", type: "choice",
      names: ["Hikvision 8-Port PoE Switch (DS-3E0109P-E)", "Hikvision 16-Port PoE Switch (DS-3E0318P-E)"] },
    { key: "cable", titleKey: "cctvkit_step_cable", type: "qty",
      names: ["Hikvision CAT6 UTP Network Cable 305m"] },
  ],
  tier: (sel) => {
    if (!sel.find((s) => s.groupKey === "recorder")) return { pct: 0, code: null };
    const hasCams = sel.some((s) => s.groupKey === "cameras" && s.qty > 0);
    const hasStorage = !!sel.find((s) => s.groupKey === "storage");
    const hasSwitch = !!sel.find((s) => s.groupKey === "network");
    if (hasCams && hasStorage && hasSwitch) return { pct: 15, code: "CCTV15" };
    if (hasCams && hasStorage) return { pct: 10, code: "CCTV10" };
    return { pct: 0, code: null };
  },
};
